module.exports = __webpack_public_path__ + "static/media/HelpInfo.4dacd56c.svg";